import type { ReactNode } from "react";
import { useT } from "@/contexts/I18nContext";

/** A heading and a slot. Sections whose bodies arrive later show the heading. */
export function SectionShell({
  titleKey,
  titleParams,
  actions,
  children,
}: {
  titleKey: string;
  titleParams?: Record<string, unknown>;
  actions?: ReactNode;
  children?: ReactNode;
}) {
  const t = useT();
  return (
    <div>
      <div className="flex items-start justify-between gap-4">
        <h1 className="font-display text-2xl text-ink">{t(titleKey, titleParams)}</h1>
        {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
      </div>
      <div className="mt-6">{children}</div>
    </div>
  );
}
